var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustseftyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 247,
    viewBox: "0 0 244 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_97_1897)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.688,
    height: 140.688,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 121.84 142.752)",
    fill: "url(#paint0_linear_97_1897)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.688,
    height: 140.688,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 121.84 107.064)",
    fill: "url(#paint1_linear_97_1897)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.688,
    height: 140.688,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 121.84 71.376)",
    fill: "url(#paint2_linear_97_1897)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.688,
    height: 140.688,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 121.84 35.688)",
    fill: "url(#paint3_linear_97_1897)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140.688,
    height: 140.688,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 121.84 0)",
    fill: "url(#paint4_linear_97_1897)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_97_1897",
    x: 0,
    y: 0,
    width: 243.68,
    height: 283.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 6752
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_97_1897"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_1897",
    x1: 157.244,
    y1: 155.786,
    x2: 30.6252,
    y2: 155.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012926",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_97_1897",
    x1: 155.486,
    y1: 154.028,
    x2: 9.04109,
    y2: 159.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_97_1897",
    x1: 151.969,
    y1: 150.511,
    x2: 9.04064,
    y2: 156.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_97_1897",
    x1: 155.214,
    y1: 157.817,
    x2: 4.98913,
    y2: 159.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_97_1897",
    x1: 141.417,
    y1: 139.959,
    x2: -0.0146565,
    y2: 141.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012926"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustseftyImg);
export default __webpack_public_path__ + "static/media/trust&seftyImg.4acf82303e73ee9bf9d21c028739b68b.svg";
export { ForwardRef as ReactComponent };